import React, { useEffect } from "react";
import { Grid, GridItem } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { sidebarisexpandAtom, panelAtom, userState } from "states/recoil";
import { useRecoilValue } from "recoil";

// Import your components here
import Navbar from "components/ui/Navbar";
import Footer from "components/ui/Footer";
import DashboardSuperAdmin from "views/SuperAdmin/DashboardSuperAdmin";
import SidebarSuperAdmin from "components/ui/Sidebars/SidebarSuperAdmin";

function LayoutSuperAdmin() {
  const navigate = useNavigate();
  const sidebarisexpandGet = useRecoilValue(sidebarisexpandAtom);
  const panelGet = useRecoilValue(panelAtom);
  const isLoggedIn = useRecoilValue(userState);

  useEffect(() => {
    // Here you can perform any logic you need when the state changes
  }, [panelGet]);

  let componentToRender;

  // useEffect(() => {
  //   // Here you can perform any logic you need when the state changes
  //   if (!isLoggedIn) {
  //     navigate('/');
  //   }
  // }, [isLoggedIn, navigate]);

  switch (panelGet) {
    case "home":
      componentToRender = <DashboardSuperAdmin />;
      break;

    default:
      // You can provide a default component or content here
      componentToRender = <DashboardSuperAdmin />;
      break;
  }

  return (
    <Grid
      templateAreas={`"sidebar navbar"
                  "sidebar main"
                  "sidebar footer"`}
      gridTemplateRows={"auto 1fr"}
      gridTemplateColumns={"115px 1fr"}
      gap="20px"
      color="blackAlpha.700"
      fontWeight="bold"
      mr="20px"
      mb="20px"
    >
      <GridItem
        pt="4"
        area={"sidebar"}
        style={{ position: "fixed" }}
        zIndex={99999}
      >
        <SidebarSuperAdmin />
      </GridItem>
      <GridItem mt="4" area={"navbar"}>
        <motion.div
          hidden={false}
          initial={false}
          animate={{
            width: sidebarisexpandGet ? "calc(100% - 150px)" : "100%",
          }}
          style={{
            right: 0,
            float: "right",
          }}
        >
          <Navbar />
        </motion.div>
      </GridItem>
      <GridItem mt="4" area={"main"}>
        <motion.div
          hidden={false}
          initial={false}
          animate={{
            width: sidebarisexpandGet ? "calc(100% - 150px)" : "100%",
          }}
          style={{
            right: 0,
            float: "right",
          }}
        >
          {componentToRender}
        </motion.div>
      </GridItem>
      <GridItem mt="4" area={"footer"}>
        <motion.div
          hidden={false}
          initial={false}
          animate={{
            width: sidebarisexpandGet ? "calc(100% - 150px)" : "100%",
          }}
          style={{
            right: 0,
            float: "right",
          }}
        >
          <Footer />
        </motion.div>
      </GridItem>
    </Grid>
    // ) : (
    //   // Redirect to the login page if not logged in
    //   (() => {
    //     navigate('/');
    //     return null; // This is to prevent rendering anything when navigating
    //   })()
  );
}

export default LayoutSuperAdmin;
